import { useEffect, useState, useContext } from "react";
import TimeStrip from "./time-strip";
import GridDataContext from "core/providers/grid-data-context";
import { times } from "core/times";
import { createTimeArr } from "core/lib/time-methods";
import { AppContext } from "core/providers/tv-guide.context";
import { observer } from "mobx-react-lite";
import GridRowItem from "./grid-row-item";
import dateWrapper from "core/lib/date-wrapper";

type GridColumnProps = {
  key: React.Key;
  channelList: number[];
  adjustedCurrentTime: any;
  dateItem: Date;
  gridCheck: number[];
  columnHeight: number;
  scrollParams: number[];
}

//Each column represents a date for all visible channels
const GridColumn = observer((props: GridColumnProps) => {
  const appContext = useContext(AppContext);
  const store = appContext.store;

  const gridContext = useContext(GridDataContext);
  const adjustedCurrentTime = props.adjustedCurrentTime;
  const [rowHeight, setRowHeight] = useState(0);
  const [fullTimeArr,] = useState(() => {
    return createTimeArr(times);
  });
  const [timeWindow, setTimeWindow] = useState([times[0], times[10]]);

  const [midnight, setMidnight] = useState<any>(undefined);
  const [, setNextMidnight] = useState<any>(undefined);

  useEffect(() => {
    const formattedDate = dateWrapper(props.dateItem).yearMonthDay() + "T00:00:00";

    //Shouldn't be needed as dates have time removed when building store.dates
    const currentMidnight = new Date(formattedDate);

    const nextMidnight = new Date(formattedDate);
    nextMidnight.setDate(nextMidnight.getDate() + 1);

    setMidnight(currentMidnight);
    setNextMidnight(nextMidnight);
  }, [props.dateItem]);

  // useEffect(() => {
  //   if (!Object.keys(store.schedule).length) {
  //     return;
  //   }

  //   if (!store.hasFavourites) {
  //     setChannelArr(store.channelNumbers);
  //     return;
  //   }

  //   setChannelArr(tvDataContext.shortChannelList);

  //   // setProgrammeObj(tvDataContext.dynamicData.programmeSchedule);
  // }, [store.favouriteChannelNumbers, store.schedule]);

  useEffect(() => {
    if (
      store.hasScheduleData &&
      gridContext &&
      gridContext.dimensionBlock &&
      rowHeight === 0
    ) {
      setRowHeight(gridContext.dimensionBlock.channelBlock.height + 4);
    }
  }, [store.hasScheduleData, gridContext.dimensionBlock, rowHeight, gridContext]);

  useEffect(() => {
    const hScroll = gridContext.horizontalScrollIndexes;

    if (hScroll[0] === 0 && hScroll[1] === 0) {
      setTimeWindow([fullTimeArr[0], fullTimeArr[fullTimeArr.length - 1]]);
      return;
    }

    const start = hScroll[0] - 1 < 0
      ? 0
      : hScroll[0] - 1;

    const end = hScroll[1] + 1 > fullTimeArr.length - 1
      ? fullTimeArr.length - 1
      : hScroll[1] + 1;

    const startTime = fullTimeArr[start];
    const endTime = fullTimeArr[end];

    setTimeWindow([startTime, endTime]);
  }, [fullTimeArr, gridContext.horizontalScrollIndexes]);


  const channels = store.showFavourites ? store.favouriteChannelNumbers : store.channelNumbers;

  const height = !store.showFavourites ? `${props.columnHeight}px` : "100%";

  const dateChannelIndex = store.dates.indexOf(props.dateItem);

  const date = dateWrapper(props.dateItem).yearMonthDay();
  return (
    <div
      className={`grid-column gc-${dateChannelIndex}`}
      data-date={date}
      style={{ height: height }}>
      <div className="strip-holder">
        <TimeStrip
          dateItem={props.dateItem}
          topPosition={props.scrollParams[0]} />
      </div>
      {rowHeight && channels.map((number, index) => {
        const key = `grw-${number}-${index}`;

        return <GridRowItem
          key={key}
          channelNumber={number}
          channelIndex={index}
          gridContext={gridContext}
          dateItem={props.dateItem}
          store={store}
          rowHeight={rowHeight}
          adjustedCurrentTime={adjustedCurrentTime}
          timeWindow={timeWindow}
          gridCheck={props.gridCheck}
          midnight={midnight}
        />
      })}
    </div>
  );
});

export default GridColumn;
